require('./ErrorStep.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const classNames = require('classnames');
// @commons
const WizardError = require('components/commons/wizardError/wizardError');
const { formatText, FormattedText } = require('core/i18n').i18n;

const ErrorStep = ({ mainProfileView, onConfirmLeave, processType }) => {
    const errorMessage = formatText('profileEditError-title');
    const mainButtonLabel = formatText('profileEditError-backButtonLabel').toUpperCase();
    const mainButton = {
        label: mainButtonLabel
    };
    const confirmErrorClass = classNames('col-xs-offset-2', 'col-xs-8', {
        'confirm-error-step': mainProfileView
    });

    return (
        <div className={confirmErrorClass}>
            <WizardError errorMessage={errorMessage}
                mainButton={mainButton}
                onMainButtonClick={onConfirmLeave}
                processType={processType}
            >
                <FormattedText value="profileEditError-detailTitle" />
            </WizardError>
        </div>
    );
};

ErrorStep.propTypes = {
    mainProfileView: PropTypes.bool,
    onConfirmLeave: PropTypes.func.isRequired,
    processType: PropTypes.string,
}

ErrorStep.defaultProps = {
    mainProfileView: true,
    processType: null,
};

module.exports = ErrorStep;
